import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ['input', 'filterTemplate', 'containerTemplate', 'destination', 'seperator']

  selected(event) {
    this.inputTarget.value = event.detail.filter_id
    this.inputTarget.classList.add('hidden')

    post('/app/human_filters.json', { body: JSON.stringify({ filter_rule_id: event.detail.filter_id }) })
      .then(async response => {
        if (response.ok) {
          const json = await response.json

          this.destinationTarget.innerHTML = ''

          json.data.forEach((group, index) => {
            let container = this.containerTemplateTarget.innerHTML
            this.destinationTarget.insertAdjacentHTML('beforeend', container)

            let ix = this.destinationTarget.children.length - 1


            group.forEach((filter, i) => {
              let filterTemplate = this.filterTemplateTarget.innerHTML
              this.destinationTarget.children[ix].insertAdjacentHTML('beforeend', filterTemplate.replace(/__filter__/g, filter))
            })

            if (index < json.data.length - 1) {
              this.destinationTarget.children[ix].insertAdjacentHTML('afterend', this.seperatorTarget.innerHTML)
            }

          })
        } else {
          console.error("Error updating filter")
        }
      })
  }
}
